import { configureStore } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import userReducer from 'reducer/user';
import dashboardReducer from 'reducer/dashboard';
import adminReducer from 'reducer/admin';
import agencyReducer from 'reducer/agency';
import loaderReducer from 'reducer/loader';
import markupReducer from 'reducer/markup';
import hotelReducer from 'reducer/hotel';
import carReducer from 'reducer/car';
import flightReducer from 'reducer/flight';
import activityReducer from 'reducer/activity';
import cruiseReducer from 'reducer/cruise';
import totalReducer from 'reducer/total';
import settingReducer from 'reducer/settings';
import searchesReducer from 'reducer/searches';
import csvReducer from 'reducer/csv';
import countriesReducer from 'reducer/countries';
import locationsReducer from 'reducer/locations';
import bookingDetailsReducer from 'reducer/bookingDetails';
import resortReducer from 'reducer/resort';
import commissionReportReducer from 'reducer/commissionReport';
import sendReceiptReducer, { sendReceipt } from 'reducer/uploadReceipt';
import quotaReducer from 'reducer/quota';
import organizationReducer from 'reducer/organization';
import depositReducer from 'reducer/deposit';

export default configureStore({
  reducer: {
    form: formReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    loader: loaderReducer,
    admin: adminReducer,
    agency: agencyReducer,
    markup: markupReducer,
    hotel: hotelReducer,
    cruise: cruiseReducer,
    car: carReducer,
    flight: flightReducer,
    activity: activityReducer,
    total: totalReducer,
    settings: settingReducer,
    searches: searchesReducer,
    csv: csvReducer,
    countries: countriesReducer,
    locations: locationsReducer,
    bookingDetails: bookingDetailsReducer,
    resort: resortReducer,
    commissionReport: commissionReportReducer,
    sendReceipt: sendReceiptReducer,
    quota: quotaReducer,
    organization: organizationReducer,
    deposit: depositReducer,
  },
});
